<template>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>

    <div class="mt-2 text-secondary">
      <hr class="hr-right" />

      <div class="portlet mb-2 bg-transparent">
        <div class="portlet-header portlet-header p-0 py-2 px-2">
          <div class="float-end dropdown">
            <!-- reload ajax content -->
            <a
              href="#"
              aria-label="Reload Content"
              class="btn btn-sm btn-light px-2 py-1"
              @click="getMessages"
            >
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-arrow-repeat"
                viewBox="0 0 16 16"
              >
                <path
                  d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
                ></path>
                <path
                  fill-rule="evenodd"
                  d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                ></path>
              </svg>
            </a>
            <button
              type="button"
              class="dropdown-toggle btn btn-sm btn-light px-2 py-1 mt-n1"
              id="dropdownLog"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span ref="btnFilterText">{{ filterNotSeenCaption }}</span>
              <i class="fi fi-arrow-down"></i>
            </button>
            <div
              class="prefix-link-icon prefix-icon-dot dropdown-menu dropdown-menu-click-update dropdown-menu-invert end-0 mt-0"
              aria-labelledby="dropdownLog"
              style=""
            >
              <!-- <div class="dropdown-header smaller px-4 text-muted fw-medium">
                فیلتر
              </div>

               -->
              <a class="dropdown-item" href="#" @click="setFilter(false)">
                <span class="js-trigger-text">تمام پیام‌ها</span>
              </a>

              <a class="dropdown-item" href="#" @click="setFilter(true)">
                <span class="js-trigger-text">خوانده نشده</span>
              </a>
            </div>
          </div>

          <!-- <span class="d-block text-muted text-truncate fw-medium">
            Notifications
          </span> -->
        </div>

        <!-- content loaded via ajax (on page load)! -->
        <div
          class="portlet-body scrollable-vertical scrollable-styled-dark pt-0"
          :style="isMobile ? '' : 'max-height: 70vh'"
        >
          <div class="row justify-content-center">
            <div class="col-12 col-lg-11">
              <div
                class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
                v-for="item in messageList"
                :key="item.id"
              >
                <div class="card-body p-lg-4">
                  <div class="row g-4 position-relative">
                    <div class="col">
                      <div
                        class="fw-medium d-block"
                        :class="isMobile ? 'fs11px' : ''"
                      >
                        <span
                          class="d-block"
                          :class="{
                            'fw-bold': !item.seenDateTime,
                            'text-danger': !item.seenDateTime,
                          }"
                        >
                          <svg
                            width="18px"
                            height="18px"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-envelope-fill"
                            viewBox="0 0 16 16"
                            v-if="!item.seenDateTime"
                          >
                            <path
                              d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"
                            ></path>
                          </svg>
                          <!-- <svg
                            width="18px"
                            height="18px"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-envelope"
                            viewBox="0 0 16 16"
                            v-if="!item.seenDateTime"
                          >
                            <path
                              d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
                            ></path>
                          </svg> -->
                          <svg
                            width="18px"
                            height="18px"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-envelope-open"
                            viewBox="0 0 16 16"
                            v-if="item.seenDateTime"
                          >
                            <path
                              d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l5.75 3.45L8 8.917l1.25.75L15 6.217V5.4a1 1 0 0 0-.53-.882l-6-3.2ZM15 7.383l-4.778 2.867L15 13.117V7.383Zm-.035 6.88L8 10.082l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738ZM1 13.116l4.778-2.867L1 7.383v5.734ZM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2Z"
                            ></path>
                          </svg>
                          {{ item.messageType }}
                          <!-- <span
                            v-if="!item.seenDateTime"
                            class="badge bg-success fw-normal me-2"
                            >جدید</span
                          > -->
                          <span
                            v-if="!item.seenDateTime"
                            class="position-absolute me-1 mt-1 p-1 bg-danger border border-light rounded-circle"
                            ><span class="visually-hidden"
                              >پیام جدید</span
                            ></span
                          >
                        </span>

                        <div class="mt-2">
                          <a
                            class="small text-secondary"
                            :href="`#collapseDetail_${item.id}`"
                            data-bs-toggle="collapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="collapseExample"
                            @click="viewMessage(item)"
                          >
                            نمایش پیام
                            <svg
                              width="18px"
                              height="18px"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              class="bi bi-chevron-compact-down"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
                              ></path>
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-5 col-lg-4 text-start">
                      <span
                        dir="ltr"
                        class="smaller"
                        :class="isMobile ? 'fs10px' : ''"
                      >
                        <svg
                          width="18px"
                          height="18px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-envelope"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
                          ></path>
                        </svg>
                        {{ getPersianDateTime(item.sentDateTime) }}
                        <span v-if="isOverseas()"
                          >|
                          <small class="gregorianDateClass"
                            >{{ getGregorianDateTime(item.sentDateTime) }}
                          </small></span
                        >
                      </span>

                      <span
                        dir="ltr"
                        class="smaller d-block"
                        v-if="item.seenDateTime"
                        :class="isMobile ? 'fs10px' : ''"
                      >
                        <svg
                          width="18px"
                          height="18px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-eye"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                          ></path>
                          <path
                            d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                          ></path>
                        </svg>

                        {{ getPersianDateTime(item.seenDateTime) }}
                        <span v-if="isOverseas()"
                          >|
                          <small class="gregorianDateClass"
                            >{{ getGregorianDateTime(item.seenDateTime) }}
                          </small></span
                        >
                      </span>
                      <!-- <span
                        class="smaller"
                        :class="{
                          'text-success': item.transactionTypeID == 1,
                          'text-danger': item.transactionTypeID == 2,
                        }"
                        >{{ item.transactionTypeID == 1 ? '+' : '-' }}</span
                      >
                      <span class="me-2 smaller text-secondary">{{
                        item.currencyType
                      }}</span> -->
                    </div>
                  </div>
                  <div class="collapse mt-2" :id="`collapseDetail_${item.id}`">
                    <div class="card card-body small justified">
                      <!-- <span class="d-block text-success smaller mb-1"
                        ><b>متن پیام:</b></span
                      > -->
                      <p class="small justified p-0 m-0">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
                v-if="messageList.length == 0"
              >
                <div class="card-body d-flex justify-content-between">
                  <div class="w-100 pt-1 text-center">
                    <strong class="d-block fs-6 fw-medium">
                      پیامی وجود ندارد</strong
                    >
                  </div>
                </div>
              </div>
              <div class="text-center my-2">
                <button
                  class="btn btn-soft btn-light btn-sm text-black"
                  @click="moreMessageClick"
                  v-if="hasMoreRecord"
                >
                  <i class="fi fi-plus"></i>
                  <span>نمایش بیشتر</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex align-self-baseline w-100 py-2"></div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';

export default {
  components: {
    LoadingSpinner,
  },

  data() {
    return {
      isMobile: isMobile,
      hasMoreRecord: false,
      personID: 0,
      filterNotSeenCaption: 'تمام پیام‌ها',
      messageList: [],
      searchData: {
        personID: 0,
        notSeen: false,
        recordCount: 10,
      },
    };
  },
  methods: {
    async setFilter(notSeen) {
      this.searchData.notSeen = notSeen;
      this.filterNotSeenCaption = notSeen ? 'خوانده نشده' : 'تمام پیام‌ها';
      await this.getMessages();
    },
    getPersianDateTime(date) {
      /* eslint-disable */
      return (
        new persianDate(new Date(date)).format('L') +
        ' ' +
        `${new persianDate(new Date(date)).format('LT')}`
      );
    },

    getGregorianDateTime(date) {
      // eslint-disable-next-line
      return getGregorianDateTime(date);
    },
    async moreMessageClick() {
      this.searchData.recordCount += 10;
      await this.getMessages();
    },
    async viewMessage(item) {
      if (item.seenDateTime) {
        return;
      }
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post('/ST/Message/SeeTheMessage?id=' + item.id)
        .then((response) => {
          item.seenDateTime = response.data?.seenDateTime;
          this.$store.dispatch('setHasUnseenMessage', {
            personID: that.$store.getters.userPersonID,
            hasUnseenMessage: response.data?.hasUnseenMessage,
          });
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت پیام‌ها با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },

    async getMessages() {
      let that = this;
      this.$refs.spinner.show();

      await axios
        .post('/ST/Message/GetMessages', that.searchData)
        .then((response) => {
          that.messageList = response.data.messageData;
          that.hasMoreRecord =
            response.data.allRecourdCount > response.data.messageData.length;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت پیام‌ها با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
  },
  async mounted() {
    let that = this;
    const route = useRoute();
    that.personID = route.params.id;
    that.searchData.personID = route.params.id;
    await that.getMessages();
    this.$messageHub.client.on('NewMessage', async (message) => {
      if (message.personID == that.$store.getters.userPersonID) {
        await that.getMessages();
      }
    });
  },
};
</script>
